import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class DataFilterGrid extends BaseComponent {
	
	static get properties() {
		return {
		};
	}
	
	constructor() {
		super();
	
		var dataFilterGrid = this;
		setTimeout(function(){
			dataFilterGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var dataFilterGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['DATA_FILTER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['DATA_FILTER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',						
							theme: 'error primary',
							itemid: 'delete',
							disabled: true,
							'class': 'spacer-toolbar-item',
							style: 'float: right;',
							permissions: ['DATA_FILTER_MANAGEMENT:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}
			]
		});		
			
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'datafilterId',
					header: 'Filter Id',
					width: '7em'
				},
				{						
					path: 'name',
					header: 'Name',
					width: '7em'
				},	
				{						
					path: 'dataTypeDescription',
					header: 'Data Type',
					width: '7em'
				},	
				{						
					path: 'rules',
					header: 'Rules',
					width: '7em',
					renderer: function(root, column, rowData) {
						root.innerHTML = 'Rules Defined: ' + rowData.item.rules.length;
					}
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		dataFilterGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			var loadMask = grid.showLoading();
			
			DataManagementService.getDataFilteringService().getDataFilters().then(function(data){
				loadMask.remove();
				grid.activeItem = null;
				grid.items = data;	
			});			
		};
		actionRefresh();
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var rules = [];
						var ruleGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true				
							},			
							children: [								
								{						
									path: 'field',
									header: 'Field Path',					
									width: '9em'
								},
								{
									path: 'logicOperator',
									header: 'AND / OR',
									width: '6em',
									renderer: function(root, column, rowData) {
										var ruleIndex = (ruleGrid.items || []).indexOf(rowData.item);
										if (ruleIndex === 0) {
											root.innerHTML = '';
										} else {
											root.innerHTML = rowData.item.logicOperator ? rowData.item.logicOperator : 'AND';
										}
									}
								},
								{
									path: 'matchOperation',
									header: 'Match Operation',
									width: '9em'
								},
								{
									path: 'includeValue',
									header: 'Include Value',
									width: '9em'
								},
								{
									path: 'excludeValue',
									header: 'Exclude Value',
									width: '9em'
								},
								{
									path: 'excludeEmptyFlg',
									header: 'Exclude Empty',
									'text-align': 'center',
									width: '7em'
								},
								{
									path: 'caseInsensitiveFlg',
									header: 'Case Insensitive',
									'text-align': 'center',
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									ruleGrid.selectedItems = item ? [item] : [];
									if (ruleGrid.selectedItems.length > 0) {											
										ElementUtil.query(formPanel, 'editRule').disabled = false;										
										ElementUtil.query(formPanel, 'removeRule').disabled = false;										
									} else {	
										ElementUtil.query(formPanel, 'editRule').disabled = true;										
										ElementUtil.query(formPanel, 'removeRule').disabled = true;
									}	
								}
							}
						});
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'name',
											label: 'Name',											
											required: true,
											maxLength: 120											
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'dataTypeCB',
											name: 'dataType',
											label: 'Data Type',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('DataType').then(function (data) {
													var filterable = [];
													data.forEach(function(item){
														if (item.filterable) {
															filterable.push(item);
														}
													});
													
													combo.items = filterable;
													combo.required = true;
												});
											},
											placeHolder: 'Select'
										},										
										{
											tag: 'dl-section-title',
											title: 'Rules',
											colspan: 2,
											style: 'margin-top: 20px;'											
										},
										{
											tag: 'div',
											itemid: 'ruleExpression',
											colspan: 2,
											style: 'font-weight: bold; margin-bottom: 8px;'
										},
										{
											tag: 'vaadin-details',
											colspan: 2,
											children: [
												{
													tag: 'div',
													slot: 'summary',
													'class': 'hover-pointer',
													innerHTML: 'How rules combine (AND is tighter than OR)'
												},
												{
													tag: 'div',
													style: 'font-size: 13px; line-height: 1.4;',
													trustedInnerHTML: true,
													innerHTML: '<p>Existing filters with no AND/OR still require <b>every</b> rule to match (all AND). '
														+ 'AND groups bind first, then OR joins those groups. There are no extra parentheses, '
														+ 'so <i>(A or B) and C</i> is written by repeating C: <b>A AND C OR B AND C</b>.</p>'
														+ '<table style="width:100%; border-collapse:collapse;" border="1" cellpadding="4">'
														+ '<tr><th>Use case</th><th>Rules</th><th>Reads as</th><th>Sample</th><th>Result</th></tr>'
														+ '<tr><td>All conditions (legacy)</td><td>State contains TX <b>AND</b> Gallons &gt; 10</td><td>(State AND Gallons)</td><td>TX, 15</td><td>Include</td></tr>'
														+ '<tr><td>Any of two values</td><td>State = TX <b>OR</b> State = OK</td><td>(State) OR (State)</td><td>OK</td><td>Include</td></tr>'
														+ '<tr><td>AND tighter than OR</td><td>State = TX <b>OR</b> State = OK <b>AND</b> Gallons &gt; 10</td><td>(TX) OR (OK AND Gallons)</td><td>TX / 1<br>OK / 5</td><td>Include<br>Exclude</td></tr>'
														+ '<tr><td>OR group then AND</td><td>State = TX <b>AND</b> Gallons &gt; 10 <b>OR</b> State = OK <b>AND</b> Gallons &gt; 10</td><td>(TX AND Gallons) OR (OK AND Gallons)</td><td>OK / 15<br>OK / 5</td><td>Include<br>Exclude</td></tr>'
														+ '<tr><td>Exclude a value</td><td>State equals NM (Exclude Value)</td><td>(State)</td><td>NM</td><td>Exclude</td></tr>'
														+ '</table>'
												}
											]
										},
										{
											tag: 'div',
											style: 'height: 350px;',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [														
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [																				
																{
																	tag: 'vaadin-button',																	
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditRule();
																		}
																	}					
																},	
																{
																	tag: 'vaadin-button',
																	itemid: 'editRule',																	
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:edit', ' Edit')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditRule(ruleGrid.selectedItems[0]);
																		}
																	}					
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'removeRule',
																	theme: 'error primary',																						
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',					
																	children:[
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			actionRemoveRule(ruleGrid.selectedItems[0]);
																		}
																	}
																}			
															]
														},
														ruleGrid													
													]
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
															if (rules.length === 0) {
																window.DL.MessageUtil.showOkMessage('Must have at least 1 rule.', null, {
																	title: 'Validation Error'
																});																
															} else {															
																formPanel.submitForm({
																	preSubmit: function (data) {
																		//add rules
																		data.rules = rules;
																		return data;
																	},
																	actualCall: function (data) {
																		if (record) {
																			data.datafilterId = record.datafilterId;
																		}
																		return DataManagementService.getDataFilteringService().saveDataFilter(data, (record ? true : false));
																	},
																	success: function (data, responseData) {
																		window.DL.MessageUtil.showToast('Success', 'Saved Data Filter', {
																			theme: 'success',
																			position: 'top-stretch'
																		});
																		actionRefresh();
																		addEditWin.close();
																	}
																});
															}
														}
													}
												},
												{
													theme: 'secondary',
													style: 'margin-left: 10px;',
													children: [
														ElementUtil.makeIcon('vaadin:check', ' Test')
													],
													listeners: {
														click: function() {
															actionTestFilter();
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						var formatFilterExpression = function(ruleList) {
							if (!ruleList || ruleList.length === 0) {
								return 'No rules yet.';
							}
							var expression = '(';
							ruleList.forEach(function(rule, index) {
								var fieldLabel = rule.field || '?';
								if (index === 0) {
									expression += fieldLabel;
								} else if (rule.logicOperator === 'OR') {
									expression += ') OR (' + fieldLabel;
								} else {
									expression += ' AND ' + fieldLabel;
								}
							});
							expression += ')';
							return 'Keep when: ' + expression;
						};

						var actionRefreshRules = function() {														
							ruleGrid.activeItem = null;
							ruleGrid.items = rules.slice(0);
							var expressionEl = ElementUtil.query(formPanel, 'ruleExpression');
							if (expressionEl) {
								expressionEl.innerHTML = formatFilterExpression(rules);
							}
						};
						
						if (record) {	
							formPanel.load(record);
							
							//load rules
							rules = [];							
							record.rules.forEach(function(rule){										
								rules.push(Object.assign({}, rule));
							});
						}
						actionRefreshRules();
						
						var actionRemoveRule = function(rule) {
							var newItems = [];
							rules.forEach(function(item){
								if (item.field !== rule.field) {
									newItems.push(item);
								}
							});	
							if (newItems.length > 0) {
								newItems[0].logicOperator = 'AND';
							}
							rules = newItems;
							actionRefreshRules();
						};

						var actionTestFilter = function() {
							if (rules.length === 0) {
								window.DL.MessageUtil.showOkMessage('Must have at least 1 rule.', null, {
									title: 'Validation Error'
								});
								return;
							}

							var dataType = ElementUtil.query(formPanel, 'dataTypeCB').value;
							var uniqueFields = [];
							var seenFields = {};
							rules.forEach(function(rule) {
								if (rule.field && !seenFields[rule.field]) {
									seenFields[rule.field] = true;
									uniqueFields.push(rule.field);
								}
							});

							var testWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Test Filter',
								icon: 'vaadin:check',
								width: 700,
								height: 560,
								listeners: {
									ready: function() {
										testWin.show();

										var messagePanel = ElementUtil.create({
											tag: 'div',
											'class': 'regex-tester-message',
											innerHTML: formatFilterExpression(rules)
										});

										var fieldInputs = uniqueFields.map(function(fieldPath) {
											return {
												tag: 'vaadin-text-field',
												name: fieldPath,
												label: fieldPath,
												colspan: 2
											};
										});

										var testFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												messagePanel,
												{
													tag: 'vaadin-form-layout',
													children: fieldInputs.concat([
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:check', ' Test')
																	],
																	listeners: {
																		click: function() {
																			var fieldValues = testFormPanel.getData();
																			var loadMask = testFormPanel.showLoading('Checking...');
																			DataManagementService.getDataFilteringService().testDataFilter({
																				dataType: dataType,
																				rules: rules,
																				fieldValues: fieldValues
																			}).then(function(results) {
																				loadMask.remove();
																				messagePanel.classList.remove('regex-tester-error', 'regex-tester-matched', 'regex-tester-unmatched');
																				if (results.errorMessage) {
																					messagePanel.classList.add('regex-tester-error');
																					messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:close"></vaadin-icon> ' + results.errorMessage + '</b>';
																				} else if (results.included) {
																					messagePanel.classList.add('regex-tester-matched');
																					messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:check-circle"></vaadin-icon> Included</b>'
																						+ '<div>' + (results.expression || '') + '</div>';
																				} else {
																					messagePanel.classList.add('regex-tester-unmatched');
																					messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:close-circle"></vaadin-icon> Excluded</b>'
																						+ '<div>' + (results.expression || '') + '</div>';
																				}
																			});
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Close',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			testWin.close();
																		}
																	}
																}
															]
														}
													])
												}
											]
										});

										testWin.addToContentElement(testFormPanel);
									}
								}
							});
						};
						
						var actionAddEditRule = function(rule) {
							
							//data type must be selected 
							var dataType = ElementUtil.query(formPanel, 'dataTypeCB').value;
							if (!dataType) {
								window.DL.MessageUtil.showOkMessage('Must select data type first.', null, {
									title: 'Validation Error'
								});
							} else {							
								var addEditRuleWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: rule ? 'Edit' : 'Add',
								icon: 'vaadin:edit',
								width: 600,
								height: 565,
								listeners: {
									ready: function () {
										addEditRuleWin.show();									
								
										
										var ruleFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [
														{
															tag: 'vaadin-combo-box',
															itemid: 'fieldCB',
															name: 'field',															
															label: 'Field',
															'item-value-path': 'fieldPath',
															'item-label-path': 'name',																													
															postinit: function (combo) {
																DataManagementService.getDataFilteringService().getDataFieldDefinitions(dataType).then(function(data) {
																	data.dataField.sort(function(a, b) {
																		return a.name.localeCompare(b.name);
																	});
																	combo.items = data.dataField;	
																	combo.required = true;
																});
															},
															placeHolder: 'Select'
														},
														{
															tag: 'vaadin-combo-box',
															itemid: 'logicOperatorCB',
															name: 'logicOperator',
															label: 'Combine With Previous Rule',
															'item-value-path': 'code',
															'item-label-path': 'description',
															value: 'AND',
															helperText: 'AND is tighter than OR. Example: A OR B AND C means A OR (B AND C).',
															postinit: function (combo) {
																var isFirstRule = !rule ? rules.length === 0 : rules.indexOf(rule) === 0;
																combo.disabled = isFirstRule;
																Service.getLookupService().getLookupValues('DataFilterLogicOperator').then(function(data) {
																	combo.items = data;
																	if (!combo.value) {
																		combo.value = 'AND';
																	}
																});
															},
															placeHolder: 'Select'
														},														
														{
															tag: 'vaadin-combo-box',															
															itemid: 'matchOperationCB',
															name: 'matchOperation',															
															label: 'Match Operator',
															'item-value-path': 'code',
															'item-label-path': 'description',
															value: 'CONTAINS',															
															postinit: function (combo) {
																Service.getLookupService().getLookupValues('DataFilterMatchOperator').then(function(data) {																	
																	combo.items = data;
																	combo.required = true;
																});
															},															
															placeHolder: 'Select'
														},
														{
															tag: 'div',
															trustedInnerHTML: true,
															innerHTML: '<dl-regex-tester></dl-regex-tester>'
														},
														{
															tag: 'vaadin-text-field',
															itemid: 'includeValue',
															name: 'includeValue',
															label: 'Include Value',	
															required: true,
															maxLength: 1024,
															listeners: {
																change: function(e) {
																	var newValue = e.target.value;
																	if (newValue && newValue !== '') {
																		ElementUtil.query(ruleFormPanel, 'excludeValue').disabled = true;
																	} else {
																		ElementUtil.query(ruleFormPanel, 'excludeValue').disabled = false;
																	}
																}
															}
														},
														{
															tag: 'vaadin-text-field',
															itemid: 'excludeValue',
															name: 'excludeValue',
															label: 'Exclude Value',
															required: true,
															maxLength: 1024,
															listeners: {
																change: function(e) {
																	var newValue = e.target.value;
																	if (newValue && newValue !== '') {
																		ElementUtil.query(ruleFormPanel, 'includeValue').disabled = true;
																	} else {
																		ElementUtil.query(ruleFormPanel, 'includeValue').disabled = false;
																	}
																}
															}											
														},
														{
															tag: 'vaadin-checkbox',
															name: 'excludeEmptyFlg',
															label: 'Exclude Empty'																	
														},
														{
															tag: 'vaadin-checkbox',
															name: 'caseInsensitiveFlg',
															checked: true,
															label: 'Case Insensitive'																	
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', (rule ? ' Update' : ' Add'))
																	],
																	listeners: {
																		click: function() {															

																			//must have either a include or exclude

																			//get data
																			var data = ruleFormPanel.getData();
																			if (!data.logicOperator) {
																				data.logicOperator = 'AND';
																			}
																			if (!rule) {
																				if (rules.length === 0) {
																					data.logicOperator = 'AND';
																				}
																				rules.push(data);																			
																			} else {
																				rule.field = data.field;
																				rule.matchOperation = data.matchOperation;
																				rule.logicOperator = data.logicOperator;
																				rule.includeValue = data.includeValue;
																				rule.excludeValue = data.excludeValue;
																				rule.excludeEmptyFlg = data.excludeEmptyFlg;
																				rule.caseInsensitiveFlg = data.caseInsensitiveFlg;																			
																			}
																			
																			//refresh rules
																			actionRefreshRules();
																			addEditRuleWin.close();
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addEditRuleWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});			

										addEditRuleWin.addToContentElement(ruleFormPanel);
										
										
										if (rule) {
											ruleFormPanel.load(rule);											
										}
										
									}
								}
							});
							}
						};
						
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete "' + record.name + '"?</b> <br><i class="fas fa-exclamation-triangle warning-icon"></i>This config will be removed from associated Integrations.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							DataManagementService.getDataFilteringService().deleteDataFilter(record.datafilterId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed '+ record.name, {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};	
		
	}
	
}
customElements.define('dl-datafilter-grid', DataFilterGrid);